import * as types from '../mutation-types/editor-merge-fields'

const namespaced = true
export const namespace = 'EditorMergeFields'

// state
const state = {
    selectedMergeFieldEl: null,
    selectedMergeFieldName: null,
    selectedMergeFieldOptions: null,
    selectedMergeFieldEditable: false,

    showMergeFieldsPreview: false,
    showMergeFieldsDefaults: false,
    selectedMergeFieldsContact: null,
    mergeFieldsContacts: [],

    mergeContactFields: [],
    mergeContactValues: {},

    mergeFieldsOptions: {},
    mergeFieldsDefaults: {},
}

// mutations
const mutations = {
    [types.SET_SELECTED_MERGE_FIELD](s, { mergeFieldEl }) {
        s.selectedMergeFieldEl = mergeFieldEl || null
        if (!mergeFieldEl) {
            s.selectedMergeFieldName = null
            s.selectedMergeFieldOptions = null
            s.selectedMergeFieldEditable = false
        }
    },
    [types.SET_SELECTED_MERGE_FIELD_NAME](s, mergeFieldName) {
        s.selectedMergeFieldName = mergeFieldName
    },
    [types.SET_SELECTED_MERGE_FIELD_OPTIONS](s, mergeFieldOptions) {
        s.selectedMergeFieldOptions = mergeFieldOptions
    },
    [types.SET_SELECTED_MERGE_FIELD_EDITABLE](s, editable) {
        s.selectedMergeFieldEditable = editable
    },

    [types.SET_SHOW_MERGE_FIELDS_PREVIEW](s, show) {
        s.showMergeFieldsPreview = !!show
    },
    [types.SET_SHOW_MERGE_FIELDS_DEFAULTS](s, show) {
        s.showMergeFieldsDefaults = !!show
    },
    [types.SET_SELECTED_MERGE_FIELDS_CONTACT](s, contact) {
        s.selectedMergeFieldsContact = contact
    },
    [types.SET_MERGE_FIELDS_CONTACTS](s, contacts) {
        s.mergeFieldsContacts = contacts
    },

    [types.SET_MERGE_CONTACT_FIELDS](s, fields) {
        s.mergeContactFields = fields
    },
    [types.SET_MERGE_CONTACT_VALUES](s, values) {
        s.mergeContactValues = values
    },

    [types.SET_MERGE_FIELDS_OPTIONS](s, values) {
        s.mergeFieldsOptions = values
    },
    [types.SET_MERGE_FIELDS_DEFAULTS](s, defaults) {
        s.mergeFieldsDefaults = {
            ...s.mergeFieldsDefaults,
            ...defaults,
        }
    },
}

// actions
const actions = {
    selectMergeField({commit}, payload) {
        commit(types.SET_SELECTED_MERGE_FIELD, payload)
    },
    unselectMergeField({commit}) {
        commit(types.SET_SELECTED_MERGE_FIELD, {})
    },
    setSelectedMergeFieldName({commit}, name) {
        commit(types.SET_SELECTED_MERGE_FIELD_NAME, name)
    },
    setSelectedMergeFieldOptions({commit}, options) {
        commit(types.SET_SELECTED_MERGE_FIELD_OPTIONS, options)
    },
    setSelectedMergeFieldEditable({commit}, editable) {
        commit(types.SET_SELECTED_MERGE_FIELD_EDITABLE, editable)
    },

    setShowMergeFieldsPreview({commit}, show) {
        commit(types.SET_SHOW_MERGE_FIELDS_PREVIEW, show)
    },
    setShowMergeFieldsDefaults({commit}, show) {
        commit(types.SET_SHOW_MERGE_FIELDS_DEFAULTS, show)
    },
    setSelectedMergeFieldsContact({commit}, contact) {
        commit(types.SET_SELECTED_MERGE_FIELDS_CONTACT, contact)
    },
    setMergeFieldsContacts({commit}, contacts) {
        commit(types.SET_MERGE_FIELDS_CONTACTS, contacts)
    },

    setMergeContactFields({commit}, fields) {
        commit(types.SET_MERGE_CONTACT_FIELDS, fields)
    },
    setMergeContactValues({commit}, values) {
        commit(types.SET_MERGE_CONTACT_VALUES, values)
    },

    setMergeFieldsOptions({commit}, options) {
        commit(types.SET_MERGE_FIELDS_OPTIONS, options)
    },
    setMergeFieldsDefaults({commit}, defaults) {
        commit(types.SET_MERGE_FIELDS_DEFAULTS, defaults)
    },
}

// getters
const getters = {
    selectedMergeFieldEl: s => {
        return s.selectedMergeFieldEl
    },
    selectedMergeFieldName: s => {
        return s.selectedMergeFieldName
    },
    selectedMergeFieldOptions: s => {
        return s.selectedMergeFieldOptions
    },
    selectedMergeFieldEditable: s => {
        return s.selectedMergeFieldEditable
    },
    selectedMergeContactFields: s => {
        if (s.selectedMergeFieldName === null) {
            return []
        }
        return s.mergeContactFields
            .filter(f => f.toLowerCase().includes(s.selectedMergeFieldName.toLowerCase()))
    },

    showMergeFieldsPreview: s => {
        return s.showMergeFieldsPreview
    },
    showMergeFieldsDefaults: s => {
        return s.showMergeFieldsDefaults
    },
    selectedMergeFieldsContact: s => {
        return s.selectedMergeFieldsContact
    },
    mergeFieldsContacts: s => {
        return s.mergeFieldsContacts
    },

    mergeContactFields: s => {
        return s.mergeContactFields
    },
    mergeContactValues: s => {
        return s.mergeContactValues
    },

    mergeFieldsOptions: s => {
        return s.mergeFieldsOptions
    },
    mergeFieldsDefaults: s => {
        return s.mergeFieldsDefaults
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
